// extracted by mini-css-extract-plugin
export default {"container":"ProjectList_container__TiDD6","list":"ProjectList_list__TruCU"};